import { storeToRefs } from 'pinia';
import { type Ref, computed } from 'vue';
import useTournamentCenterEntrance from '@/components/tournamentCenter/entrance/useTournamentCenterEntrance';
import { MarketPage } from '@/interface/enum';
import { useZone } from '@/libraries/composables/useZone';
import { isSoccer } from '@/libraries/helpers/sportsHelper';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useRootStore } from '@/stores/rootStore';

export function useFeaturedVisibility(haveEvent: Ref<boolean>) {
    const { sportType, marketPage, isMixParlayMode, isAsi } = storeToRefs(useRootStore());
    const { isBetBuilderPrebuiltEnabled, isEuroSite, isMpCombinationEnabled } = storeToRefs(useFeatureToggleStore());
    const { isShowTournamentCenterEntrance } = useTournamentCenterEntrance();
    const { isInSimulationSportsZone, isInMultipleSportsZone } = useZone();

    const isMpCombinationsEnabled = computed(
        () => isAsi.value
            && isMixParlayMode.value
            && isMpCombinationEnabled.value
            && haveEvent.value
            && !isInSimulationSportsZone.value
            && !isInMultipleSportsZone.value,
    );

    const isBetBuilderCombinationsEnabled = computed(() => {
        if (isEuroSite.value) {
            return false;
        }

        if (isInSimulationSportsZone.value || isInMultipleSportsZone.value) {
            return false;
        }

        if (isMixParlayMode.value) {
            return false;
        }

        if (!isBetBuilderPrebuiltEnabled.value) {
            return false;
        }

        if (!isSoccer(sportType.value)) {
            return false;
        }

        if (!haveEvent.value) {
            return false;
        }

        if (marketPage.value === MarketPage.Live) {
            return true;
        }

        if (marketPage.value === MarketPage.Outright) {
            return false;
        }

        if (isShowTournamentCenterEntrance.value) {
            return false;
        }

        return true;
    });

    const isTournamentCenterEntranceEnabled = computed(() => {
        if (isInSimulationSportsZone.value || isInMultipleSportsZone.value) {
            return false;
        }

        if (isSoccer(sportType.value) && marketPage.value === MarketPage.Live && isBetBuilderCombinationsEnabled.value) {
            return false;
        }

        return isShowTournamentCenterEntrance.value;
    });

    return {
        isTournamentCenterEntranceEnabled,
        isBetBuilderCombinationsEnabled,
        isMpCombinationsEnabled,
    };
}
